import configure from '../configure'
import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default class Award {

  fetch () {
    return Vue.http.get(configure.api_url + 'awards').then(response => {
      return response
    })
  }

  get (id) {
    return Vue.http.get(configure.api_url + 'awards/' + id).then(response => {
      return response
    })
  }

  put (award) {
    return Vue.http.put(
      configure.api_url + 'awards/' + award.id,
      award
    ).then(response => {
      return response
    })
  }

  post (award) {
    return Vue.http.post(
      configure.api_url + 'awards',
      award
    ).then(response => {
      return response
    })
  }

  delete (id) {
    return Vue.http.delete(
      configure.api_url + 'awards/' + id
    ).then(response => {
      return response
    })
  }
}



/** WEBPACK FOOTER **
 ** ./src/api/award.js
 **/